import { Badge } from '@/components/ui/badge'

type Props = {
  type?: string | null
}

export const TwoFAIndicator = ({ type }: Props) => {
  switch (type) {
    case 'na':
      return <Badge variant="outline">n/a</Badge>
    case 'totp':
      return <Badge variant="secondary">app</Badge>
    case 'email':
      return <Badge variant="secondary">email</Badge>
    default:
      return <Badge variant="destructive">none</Badge>
  }
}
